import { Component, OnInit, ViewChild, TemplateRef } from "@angular/core";
import { AuthenticateService } from "../../shared/services/authenticate.service";
import { Router } from "@angular/router";
import { ngxLoadingAnimationTypes, NgxLoadingComponent } from "ngx-loading";
// import { MessagingService } from "../../shared/messaging.service";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import { CognitoService } from "src/app/shared/services/cognito.service";
import { TokenStorageService } from "src/app/shared/services/token.service";
import { Auth } from "aws-amplify";
import { FileUploadService } from "src/app/shared/services/fileupload.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.sass"],
})
export class LoginComponent implements OnInit {
  @ViewChild("ngxLoading") ngxLoadingComponent: NgxLoadingComponent;
  @ViewChild("customLoadingTemplate") customLoadingTemplate: TemplateRef<any>;
  public ngxLoadingAnimationTypes = ngxLoadingAnimationTypes;
  public model: any = {};
  public type: string;
  public loading: boolean;
  fileName = "package.json";
  slideConfig2 = {
    className: "center",
    centerMode: true,
    infinite: true,
    centerPadding: "0",
    slidesToShow: 1,
    speed: 500,
    dots: true,
  };
  globalImgUrl: string;
  message;
  show: any[] = [];
  loginForm: FormGroup;
  updatepwdForm: FormGroup;
  alert: any[] = [];
  display: string = "none";
  groupName: any;

  constructor(
    private cognitoService: CognitoService,
    private formBuilder: FormBuilder,
    private authService: AuthenticateService,
    private tokenStorage: TokenStorageService,
    private fileService: FileUploadService,
    private router: Router
  ) {
    this.loading = false;
  }

  ngOnInit() {
    if (!this.globalImgUrl) {
      this.globalImgUrl = this.authService.s3url();
    }
    this.show[0] = false;
    this.show[1] = false;

    this.type = "login";
    this.loading = false;
    this.loginForm = this.formBuilder.group({
      email: ["", Validators.required],
      password: ["", Validators.required],
      newPassword: [""],
    });
    // this.updatepwdForm = this.formBuilder.group({
    //   email: ['', Validators.required],
    //   password: ['', Validators.required],
    //   newPassword: ['', Validators.required],
    // });
  }
  showhidepwd(type) {
    if (type == "password") {
      this.show[0] = !this.show[0];
    } else if (type == "newpassword") {
      this.show[1] = !this.show[1];
    }
  }

  calllogin() {
    this.type = "login";
  }
  public loginUser(): void {
    this.loading = true;
    this.cognitoService
      .signIn(this.model)
      .then((res: any) => {
        if (res.challengeName) {
          if (res.challengeName == "NEW_PASSWORD_REQUIRED") {
            this.loading = false;
            // Swal.fire({ text: 'New password required.' });
          }
        } else {
          this.isUserAuthenticated();
        }
      })
      .catch(() => {
        this.loading = false;
      });
  }
  async isUserAuthenticated() {
    this.cognitoService.isAuthenticated().then(async (isAuthenticated: any) => {
      if (isAuthenticated) {
        // this.fileService.getFiles(this.fileName);
        await this.getCurrentSession();
        await this.getCurrentUserInfo();
        this.loginForm.reset();
      } else {
        this.router.navigate(["/login"]);
        this.loginForm.reset();
      }
    });
  }
  async getCurrentSession() {
    let checkSession = (await Auth.currentSession()).getIdToken().getJwtToken();
    let session = await Auth.currentSession();
    console.log("@@Session in login:", session);
    await Auth.currentSession().then((session) => {
      var idTokenExpire = session.getIdToken().getExpiration();
      var refreshToken = session.getRefreshToken().getToken();
      this.tokenStorage.saveExpiryToken(idTokenExpire);
      this.tokenStorage.saveToken(checkSession);
      this.tokenStorage.saveRefreshToken(refreshToken);
      this.tokenStorage.saveUser(session);
    });
  }
  async getCurrentUserInfo() {
    this.cognitoService.getUser().then((res: any) => {
      this.groupName = res.attributes.family_name;
      this.tokenStorage.saveGroup(this.groupName);
      this.router.navigate(["/home"]);
    });
  }
  focusFn() {
    this.display = "block";
  }

  checknewpassword(pwd) {
    console.log("pwd", pwd);
    if (pwd != "") {
      var lowerCaseLetters = /[a-z]/g;
      var upperCaseLetters = /[A-Z]/g;
      var numbers = /[0-9]/g;
      var specialchar = /[!@#\$%\^&\*]/g;
      for (let i = 0; i < 5; i++) {
        if (i == 0) {
          this.alert[i] = pwd.match(lowerCaseLetters) ? true : false;
          console.log("alert", this.alert[i]);
        } else if (i == 1) {
          this.alert[i] = pwd.match(upperCaseLetters) ? true : false;
        } else if (i == 2) {
          this.alert[i] = pwd.match(numbers) ? true : false;
        } else if (i == 3) {
          this.alert[i] = pwd.match(specialchar) ? true : false;
        } else if (i == 4) {
          this.alert[i] = pwd.length >= 8 ? true : false;
        }
      }
    } else {
      for (let i = 0; i < 5; i++) {
        this.alert[i] = false;
      }
    }
  }
}
